import React from 'react';
import { User, Lock, Bell, Globe, Users, Shield, HelpCircle, Save } from 'lucide-react';
export function Settings() {
  return <div data-id="element-1844">
      <div className="flex justify-between items-center mb-6" data-id="element-1845">
        <h1 className="text-2xl font-bold" data-id="element-1846">Settings</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1847">
        {/* Settings Navigation */}
        <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-1848">
          <div className="space-y-1" data-id="element-1849">
            <button className="w-full flex items-center p-3 bg-orange-50 text-orange-500 rounded-md font-medium" data-id="element-1850">
              <User size={18} className="mr-3" data-id="element-1851" />
              Profile Settings
            </button>
            <button className="w-full flex items-center p-3 text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1852">
              <Lock size={18} className="mr-3" data-id="element-1853" />
              Security & Password
            </button>
            <button className="w-full flex items-center p-3 text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1854">
              <Bell size={18} className="mr-3" data-id="element-1855" />
              Notifications
            </button>
            <button className="w-full flex items-center p-3 text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1856">
              <Globe size={18} className="mr-3" data-id="element-1857" />
              Language & Region
            </button>
            <button className="w-full flex items-center p-3 text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1858">
              <Users size={18} className="mr-3" data-id="element-1859" />
              User Management
            </button>
            <button className="w-full flex items-center p-3 text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1860">
              <Shield size={18} className="mr-3" data-id="element-1861" />
              Permissions
            </button>
            <button className="w-full flex items-center p-3 text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1862">
              <HelpCircle size={18} className="mr-3" data-id="element-1863" />
              Help & Support
            </button>
          </div>
        </div>
        {/* Profile Settings Form */}
        <div className="bg-white rounded-lg shadow-sm p-6 md:col-span-2" data-id="element-1864">
          <h2 className="text-lg font-semibold mb-4" data-id="element-1865">Profile Settings</h2>
          <div className="mb-6 flex items-center" data-id="element-1866">
            <div className="h-20 w-20 bg-gray-700 rounded-full flex items-center justify-center text-white text-2xl font-bold mr-4" data-id="element-1867">
              J
            </div>
            <div data-id="element-1868">
              <button className="px-3 py-1 bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors" data-id="element-1869">
                Change Avatar
              </button>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1870">
                JPG, GIF or PNG. Max size 800K
              </p>
            </div>
          </div>
          <div className="space-y-4" data-id="element-1871">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1872">
              <div data-id="element-1873">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1874">
                  First Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" defaultValue="John" data-id="element-1875" />
              </div>
              <div data-id="element-1876">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1877">
                  Last Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" defaultValue="Doe" data-id="element-1878" />
              </div>
            </div>
            <div data-id="element-1879">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1880">
                Email Address
              </label>
              <input type="email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" defaultValue="admin@example.com" data-id="element-1881" />
            </div>
            <div data-id="element-1882">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1883">
                Job Title
              </label>
              <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" defaultValue="System Administrator" data-id="element-1884" />
            </div>
            <div data-id="element-1885">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1886">
                Department
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1887">
                <option data-id="element-1888">IT Department</option>
                <option data-id="element-1889">Human Resources</option>
                <option data-id="element-1890">Finance</option>
                <option data-id="element-1891">Operations</option>
                <option data-id="element-1892">Marketing</option>
              </select>
            </div>
            <div data-id="element-1893">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1894">
                Bio
              </label>
              <textarea className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" rows={4} defaultValue="System administrator responsible for managing the committee management platform." data-id="element-1895"></textarea>
            </div>
            <div className="flex justify-end" data-id="element-1896">
              <button className="flex items-center px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-1897">
                <Save size={18} className="mr-2" data-id="element-1898" />
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}